export enum Actions {
  OPEN = '@NOTIFICATION/OPEN',
  CLOSE = '@NOTIFICATION/CLOSE'
}
